<template>
    <div class="overflow-hidden flex">
        <transition enter-active-class="transform ease-out duration-150 transition"
                    enter-class="translate-y-2 opacity-0 sm:translate-y-0"
                    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                    leave-active-class="transform ease-out duration-150 transition"
                    leave-class="translate-x-0 opacity-100"
                    leave-to-class="-translate-x-full opacity-0"
        >
            <div class="w-full"
                 v-show="! hasAccount"
            >
                <h1 class="text-xl mb-6">Your Details</h1>

                <form @submit.prevent="checkForAccount">
                    <form-input v-model="form.email"
                                type="email"
                                label="Email"
                                name="email"
                                id="email"
                                class="w-full"
                                :required="true"
                                :error="getErrorFor('email')"
                    ></form-input>

                    <div class="flex justify-end w-full">
                        <form-button type="submit">
                            Continue
                        </form-button>
                    </div>
                </form>
            </div>
        </transition>

        <transition enter-active-class="transform ease-out duration-150 transition delay-150"
                    enter-class="translate-x-full opacity-0"
                    enter-to-class="translate-x-0 opacity-100"
                    leave-active-class="transform ease-out duration-150 transition"
                    leave-class="translate-x-0 opacity-100"
                    leave-to-class="-translate-x-full opacity-0"
        >
            <div class="w-full"
                 v-show="hasAccount"
            >
                <h1 class="text-xl mb-4">Welcome Back</h1>
                <p class="text-gray-600 mb-2">
                    It looks like you've already got an account with us. Please enter your account password below.
                </p>

                <form @submit.prevent="login">
                    <form-input v-model="form.password"
                                type="password"
                                label="Password"
                                name="password"
                                id="password"
                                :required="true"
                                :error="getErrorFor('password')"
                                ref="password"
                    ></form-input>

                    <div class="flex flex-col sm:flex-row flex-wrap sm:flex-no-wrap items-start justify-between">
                        <a :href="route('customer.password.request')"
                           class="text-sm text-primary-600 hover:underline"
                        >
                            Forgot Password?
                        </a>

                        <div class="flex flex-wrap flex-col-reverse sm:flex-row sm:space-x-6 w-full sm:w-auto mt-4">
                            <form-button colour="gray"
                                         class="w-full sm:w-auto"
                                         @click.native="clearAccount"
                            >
                                Back
                            </form-button>

                            <form-button type="submit"
                                         class="w-full sm:w-auto"
                            >
                                Continue
                            </form-button>
                        </div>
                    </div>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
    import FormInput from "../../components/form/Input";
    import FormButton from "../../components/form/public/Button";

    import Form from "../../mixins/Form";

	export default {
	    data() {
	        return {
	            hasAccount: false,

	            form: {
	                email: '',
                    password: '',
                }
            }
        },

        components: { FormInput, FormButton },

		mixins: [Form],

        methods: {
            checkForAccount() {
                this.post('/checkout/account')
                    .then(response => {
                        if (response.status === 201) {
                            return window.location = response.data;
                        }

                        this.hasAccount = true;

                        this.$nextTick(() => {
                            this.$refs.password.$el.querySelector('input').focus();
                        });
                    })
            },

            login() {
                this.post('/checkout/login')
                    .then(response => {
                        return window.location = response.data;
                    });
            },

            clearAccount() {
                this.form.email = '';
                this.form.password = '';
                this.hasAccount = false
            }
        }
	}
</script>
